import React, { useState, useEffect, useRef } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { useSpring, animated } from '@react-spring/web';
import { useMeasure } from 'react-use';
import YoutubeIcon from 'components/icons/Youtube';
import Triangle from 'components/icons/Triangle';

const MenuTitle = styled.span`
  max-width: 90%;
`;

const VideoGalleySubMenuItems = ({
  subMenuTitle,
  subMenuSelected,
  subMenuList = [],
  onSelectedVideo = () => {},
  onSelectedSubmenu = () => {},
  videoSelected = {},
}) => {
  const [submenuOpen, toggleSubmenuOpen] = useState(
    subMenuTitle === subMenuSelected,
  );

  const defaultHeight = '0px';
  const [contentHeight, setContentHeight] = useState(defaultHeight);
  const [subVideoItemsRefHeight, { height }] = useMeasure();
  const getProperHeight = () => {
    if (submenuOpen) {
      return `${contentHeight}px`;
    }
    return '0px';
  };
  const expand = useSpring({
    height: getProperHeight(),
    pointerEvents: submenuOpen ? 'all' : 'none',
  });
  const fade = useSpring({
    from: { opacity: submenuOpen ? 0 : 1, delay: 200 },
    to: { opacity: submenuOpen ? 1 : 0, delay: 200, y: submenuOpen ? 0 : 200 },
  });

  useEffect(() => {
    setContentHeight(height);
    window.addEventListener('resize', setContentHeight(height));
    return window.removeEventListener('resize', setContentHeight(height));
  }, [height]);

  const renderSubVideosItems = () => (
    <animated.div
      className='flex flex-col items-left w-full'
      ref={subVideoItemsRefHeight}
      style={fade}
    >
      {subMenuList &&
        subMenuList.length > 0 &&
        subMenuList.map((v, i) => {
          if (v.title && v.video && v.video.href) {
            return (
              <button
                key={i}
                className='flex w-full h-6 mb-4 cursor-pointer font-graphie text-sm md:text-base text-mattamy-blue hover:text-action-blue'
                onClick={() => {
                  onSelectedVideo(v);
                }}
                // as={"button"}
                aria-label={
                  v.title +
                  (videoSelected && videoSelected.title === v.title
                    ? ' Video Selected'
                    : '')
                }
              >
                <div className='h-5 w-5 md:h-6 md:w-6 text-mattamy-blue'>
                  <YoutubeIcon />
                </div>

                <p
                  className={cx('ml-4', {
                    'text-action-blue':
                      videoSelected && videoSelected.title === v.title,
                  })}
                >
                  {v.title}
                </p>
              </button>
            );
          }
          return '';
        })}
    </animated.div>
  );

  return (
    <section className='w-full flex flex-col mb-4'>
      <span id='video-navigation-instructions' className='sr-only'>
        To access the video player, navigate past this section.
      </span>

      <h2 id='video-navigation-heading' className='sr-only'>
        Video Navigation.
      </h2>

      <button
        onClick={() => {
          if (subMenuSelected !== subMenuTitle) {
            toggleSubmenuOpen(true);
            onSelectedSubmenu(subMenuTitle, subMenuList[0]);
          }
        }}
        className={cx(
          'cursor-pointer flex font-trade-gothic-20 text-xl md:text-2xl mb-2 text-left',
          {
            'text-mattamy-blue ': subMenuSelected !== subMenuTitle,
            'text-action-blue ': subMenuSelected === subMenuTitle,
          },
        )}
        aria-expanded={subMenuSelected === subMenuTitle}
        aria-labelledby='video-navigation-heading submenu-title'
        aria-describedby='video-navigation-instructions'
        // as="button"
        aria-label={subMenuTitle}
      >
        <MenuTitle id='submenu-title'>{subMenuTitle} </MenuTitle>
        {subMenuSelected !== subMenuTitle && (
          <Triangle className='ml-2 w-5 h-5 text-mattamy-blue' />
        )}
        {subMenuSelected === subMenuTitle && (
          <Triangle className='ml-2 w-5 h-5 text-mattamy-blue transform rotate-180' />
        )}
      </button>
      {subMenuSelected === subMenuTitle && (
        <animated.div style={expand}>{renderSubVideosItems()}</animated.div>
      )}
    </section>
  );
};

export default VideoGalleySubMenuItems;
